import { render, staticRenderFns } from "./step_description_priority_program.vue?vue&type=template&id=1589e5af&scoped=true"
import script from "./step_description_priority_program.vue?vue&type=script&lang=js"
export * from "./step_description_priority_program.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1589e5af",
  null
  
)

export default component.exports